import initTableScroll from './ui/table_init'

const getApptSelectedDate = () => {
  const $form = $('form')
  const day = $form.find('.day-select[name="appointment[day(3i)]"]').val()
  const month = $form.find('.day-select[name="appointment[day(2i)]"]').val()
  const year = $form.find('.day-select[name="appointment[day(1i)]"]').val()
  return `${day}-${month}-${year}`
};

const initGlobalTableView = () => {
  if (!$('#global-view-page').length) return
  const selectedDate = new Date($('#selected-date-container').data('selected-date'));
  // all the response processing is done via 'null_offices/appointments/index.js.slim' partial
  $.ajax({
    url: '/appointments',
    dataType: 'script',
    data: {
      q: {
        day_gteq: selectedDate,
        day_lteq: selectedDate,
      }
    }
  }).done(() => initTableScroll())
}

window.initGlobalTableView = initGlobalTableView

const setSelectedDate = (newDate) => {
  const selectedLocale = $('.header').data('selected-locale');
  const options = { day: 'numeric', month: 'long', year: 'numeric' };
  console.log('newDate', newDate);
  const localizedDate = newDate.toLocaleDateString(selectedLocale, options);
  const rawDate = newDate.toString();
  $('#selected-date-container').data('selected-date', rawDate);
  $('#selected-date-container').text(localizedDate);
}

$(document).on('ready turbolinks:load', function() {
  const $body = $('body')

  initGlobalTableView()

  $body.on('change', '#appt-modal-user-id-selector', function() {
    const userId = $(this).val()
    const officeId = $('#appt-office-selector').val()
    const strDay = getApptSelectedDate()
    const url = $('form').data('url')

    $.ajax({
      url,
      dataType: 'script',
      data: {
        appointment: {
          user_id: userId,
          day: strDay,
          office_id: officeId,
        }
      }
    })
  });

  $body.on('change', '#null-office-appt-modal-user-id-selector', function() {
    const userId = $(this).val()
    const officeId = $('#appt-office-selector').val()
    const strDay = getApptSelectedDate()
    const url = $('form').data('url')

    $.ajax({
      url,
      dataType: 'script',
      data: {
        appointment: {
          user_id: userId,
          day: strDay,
          office_id: officeId,
        }
      }
    })
  });

  $body.on('change', '#appt-office-selector', function (event) {
    const userId = $('#null-office-appt-modal-user-id-selector').val() ||
      $('#null-office-appt-edit-modal-user-id-selector').val()
    const officeId = $(this).val()
    const strDay = getApptSelectedDate()
    const url = $('form').data('url')

    $.ajax({
      url,
      dataType: 'script',
      data: {
        appointment: {
          user_id: userId,
          day: strDay,
          office_id: officeId,
        }
      }
    })
  })

  $body.on('click', '#day-back', function (event) {
    const selectedDate = new Date($('#selected-date-container').data('selected-date'));
    const newDate = selectedDate.setDate(selectedDate.getDate() - 1);
    setSelectedDate(new Date(newDate));
    initGlobalTableView();
  })

  $body.on('click', '#day-forward', function (event) {
    const selectedDate = new Date($('#selected-date-container').data('selected-date'));
    const newDate = selectedDate.setDate(selectedDate.getDate() + 1);
    setSelectedDate(new Date(newDate));
    initGlobalTableView();
  })

  $body.on('change', '#calendar-date-picker', function (event) {
    const selectedDate = new Date(this.value);
    setSelectedDate(new Date(selectedDate));
    initGlobalTableView();
  })

  $body.on('click', '.change-view', function (event) {
    const settingId = this.dataset.settingId;
    const view = this.dataset.view;
    const oldSetting = JSON.parse(this.dataset.viewSetting);
    $.ajax({
      url: `/business_settings/${settingId}`,
      dataType: 'script',
      type: 'PATCH',
      data: {
        business_setting: {
          global_view: {
            ...oldSetting,
            table_view: view
          }
        }
      }
    }).done(function() {
      initGlobalTableView();
    });
  })

  $body.on('click', '#new-appointment-button', function (event) {
    const selectedDate = new Date($('#selected-date-container').data('selected-date'));
    const url = '/appointments/new'

    $.ajax({
      url,
      dataType: 'script',
      data: {
        appointment: {
          day: selectedDate
        }
      }
    })
  })
});
